// src/features/counterSlice.ts
import { createSlice } from '@reduxjs/toolkit';

interface GlobalState {
  globalLoading: boolean | undefined;
}

const initialState: GlobalState = {
  globalLoading: undefined,
};

export const globalSlice = createSlice({
  name: 'globalState',
  initialState,
  reducers: {
    setGlobalLoading: (state, action) => {
      state.globalLoading = action.payload;
    },
  },
});

export const { setGlobalLoading } = globalSlice.actions;

export default globalSlice.reducer;
